/**
 * InfoButton — atom (CES standard)
 * Small circular "i" toggle that reveals secondary details.
 */

export function InfoButton({
  expanded,
  label,
  testId,
  onClick,
}: {
  expanded: boolean;
  label: string;
  testId?: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={`w-[22px] h-[22px] rounded-full border text-xs font-serif italic font-bold leading-none cursor-pointer transition-colors ${
        expanded
          ? 'border-orange-500 text-orange-600 bg-orange-50'
          : 'border-gray-300 text-gray-500 hover:border-orange-500 hover:text-orange-600 hover:bg-orange-50'
      }`}
      aria-label={label}
      aria-expanded={expanded}
      title={label}
      data-testid={testId}
      onClick={onClick}
    >
      i
    </button>
  );
}
